import {
  Box,
  Button,
  FormControl,
  FormLabel,
  HStack,
  Select,
  Spinner,
  
} from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from "react";

import {
  getConnections,
  getEnumsbyAppApi,
  GettingAllTools,
} from "../../../../allApi/api";
import { firstCap } from "../../../../utiils/FirstCap";
import { useSelector } from "react-redux";
import { getActiveConnectionsTools } from "../../../../redux/reducer/toolsmodel";
import { useDispatch } from "react-redux";

function ToolsList({ handleChange, formData, waveflowTools }) {
  const [enumLoading, setenumLoading] = useState(false);
  const dispatch=useDispatch()
  const [toolsStatus, setToolsStatus] = useState(
    formData?.tool[0]?.toolType == "PreDefined"
  );
  const { activeConnectionList, activeConnectionFetched} =
  useSelector((state) => state?.toolModelData);
  // const [toolsList, setToolsList] = useState([]);
  // const [toolsConnectionList, setToolsConnectionList] = useState([]);
  const [enumTools, setEnumTools] = useState([]);

  // const getConnectionFetch = async () => {
  //   try {
  //     const res = await getConnections();
  //     let statusdata = res?.data?.connections
  //       .filter((ele) => ele.status == "ACTIVE")
  //       .map((ele) => ele.appName);
  //     let uniqueArray = [...new Set(statusdata)];

  //     setToolsConnectionList(uniqueArray);
  //   } catch (error) {
  //     console.error("error:", error);
  //   }
  // };

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const data = await GettingAllTools();

  //       setToolsList(data?.tools);
  //     } catch (error) {
  //       console.error("Error fetching models:", error);
  //     }
  //   };

  //   fetchData();
  // }, []);



  const getEnumsbyAppApiFun = async (ele) => {
    setenumLoading(true);
    try {
      const responce = await getEnumsbyAppApi({ enum: ele });
      setEnumTools(responce?.enums);
    } catch (error) {
    } finally {
      setenumLoading(false);
    }
  };

  // useEffect(() => {
  //   getConnectionFetch();
  // }, []);

  useEffect(() => {
    // if (toolsStatus && !activeConnectionFetched) {
    //   dispatch(getActiveConnectionsTools());
    // }

    if (!activeConnectionFetched) {
      dispatch(getActiveConnectionsTools());
    }
  }, [activeConnectionFetched, dispatch,toolsStatus]);


  const isFirstRender = useRef(true);

  useEffect(() => {
    const tool = formData?.tool?.[0];

    if (!tool) return;

    if (isFirstRender.current) {
      if (tool.toolType === "PreDefined" && tool.enums) {
        isFirstRender.current = false;
        return; 
      }
      isFirstRender.current = false;
    }

    if (tool.toolType === "PreDefined" && !tool.enums && tool.name) {
      getEnumsbyAppApiFun(tool.name);
    }
  }, [formData?.tool?.[0]?.name]);



  return (
    <FormControl>
      <HStack justifyContent={"space-between"} mb={1}>
        <FormLabel fontSize="14px" color={"rgba(108, 114, 117, 0.75)"}>
          Integration
        </FormLabel>
        <HStack
          gap={5}
          p={1}
          m={0}
          bg={"gray.200"}
          borderRadius={"10px"}
          boxSizing={"border-box"}
        >
          <Button
            p="5px 3px"
            m={0}
            fontSize="12px"
            h="auto"
            minH="unset"
            bg={toolsStatus ? "#FFFFFF" : "gray.200"}
            //   _hover={{ bg: toolsStatus ? "gray.100" : "gray.200" }}
            boxShadow={
              toolsStatus &&
              "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px"
            }
            onClick={() => setToolsStatus(true)}
          >
            Third Party
          </Button>
          <Button
            p="4px 3px"
            m={0}
            fontSize="12px"
            h="auto"
            minH="unset"
            bg={!toolsStatus ? "#FFFFFF" : "gray.200"}
            //   _hover={{ bg: toolsStatus ? "gray.100" : "gray.200" }}
            boxShadow={
              !toolsStatus &&
              "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px"
            }
            onClick={() => setToolsStatus(false)}
          >
            Custom
          </Button>
        </HStack>
      </HStack>

      <HStack w={"100%"} justifyContent={"space-between"}>
        <HStack w={"100%"}>
          <Select
            name="tool"
            p={0}
            m={0}
            value={formData?.tool || "None"}
            onChange={(e) => handleChange(e, toolsStatus)}
            width="100%"
            bg={"gray.200"}
            fontSize="18px"
            size={"xs"}
            borderRadius={"md"}
          >
            {toolsStatus ? (
              <>
                {" "}
                <option value={formData?.tool[0]?.name} hidden>
                  {formData?.tool[0]?.name || "None"}
                </option>
                <option value={"None"}>None</option>
                {activeConnectionList &&
                  activeConnectionList.map((ele) => (
                    <>
                      <option key={ele?.id} value={ele}>
                        {firstCap(ele)}
                      </option>
                    </>
                  ))}
              </>
            ) : (
              <>
                {" "}
                <option value={formData?.tool[0]?.display_name} hidden>
                  {formData?.tool[0]?.display_name || "None"}
                </option>
                <option value={"None"}>None</option>
                {waveflowTools &&
                  waveflowTools.map((ele) => (
                    <option key={ele?.id} value={ele?.id}>
                      {ele?.displayName}
                    </option>
                  ))}
              </>
            )}
          </Select>
          {toolsStatus && formData?.tool[0]?.name && (
            <>
              {enumLoading && (
                <Box width="100%">
                  <Spinner />
                </Box>
              )}
              {!enumLoading && (
                <Select
                  p={0}
                  m={0}
                  value={formData?.enums}
                  name="tool"
                  w={"70%"}
                  enumList="enums"
                  fontSize="18px"
                  width="100%"
                  size={"xs"}
                  bg={"gray.200"}
                  borderRadius={"md"}
                  onChange={(e) => handleChange(e, toolsStatus, "enumList")}
                >
                  <option value={formData?.tool[0]?.enums} hidden>
                    {formData?.tool[0]?.enums || "None"}
                  </option>
                  {enumTools &&
                    enumTools.map((ele, i) => (
                      <option key={i} value={ele}>
                        {ele}
                      </option>
                    ))}
                </Select>
              )}
            </>
          )}
        </HStack>
      </HStack>
    </FormControl>
  );
}

export default ToolsList;
